module.exports = __webpack_public_path__ + "img/drink_2021-thumb-510x510-1577.4b41c47e.png";